import { useQuery } from "@tanstack/react-query";
import { fetchStudy, fetchStudyReportSummary } from "../api/studyApi";
import { getTemplates } from "../api/reportsApi";

export const useStudyData = (studyId: string) => {
  return useQuery(
    ["Studies", studyId!],
    () => fetchStudy(studyId!),
    {}
  );
};

export const useTemplatesData = (studyId: string) => {
  return useQuery(
    ["Templates"],
    async () => getTemplates(studyId),
    {
      enabled: studyId != null,
      initialData: [],
    }
  );
};

export const useStudyReportSummary = () => {
  return useQuery(["StudyReportSummary"], fetchStudyReportSummary, {
    initialData: [],
  });
};
